/**
 * Begleitmaterial Renderer
 * Renders the teaching materials grid
 */

import type { BegleitmaterialData } from '../../types';
import { Carousel } from '../../components/carousel';

export function renderBegleitmaterial(data: BegleitmaterialData | null): void {
  const container = document.getElementById('begleitmaterial-grid');
  if (!container || !data) return;

  const html = data.materialien.map(material => `
    <article class="material-card splide__slide">
      <div class="material-card__image-wrapper">
        <img src="${material.vorschaubild}" alt="${material.titel}" class="material-card__image" loading="lazy">
        <a href="${material.pdf_src}" download class="material-card__download" aria-label="${material.titel} herunterladen">
          <img src="./img/icons/icon-download.svg" alt="" aria-hidden="true">
        </a>
      </div>
      <div class="material-card__content">
        <h4 class="material-card__title">${material.titel}</h4>
        ${material.beschreibung ? `
          <p class="material-card__description">${material.beschreibung}</p>
        ` : ''}
        <a href="${material.pdf_src}" download class="material-card__meta">
        <svg class="material-card__meta-icon" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M12 16l-6-6h4V4h4v6h4l-6 6z"></path>
            <path d="M2 20v2h20v-2H2z"></path>
          </svg>
          PDF (${material.dateigroesse || 'XY MB'})
        </a>
      </div>
    </article>
  `).join('');

  container.innerHTML = html;

  // Initialize carousel if carousel wrapper exists
  const carouselWrapper = container.closest('.splide');
  if (carouselWrapper) {
    new Carousel(carouselWrapper as HTMLElement);
  }
}
